<template>
  <div>
    <data-table
      ref="tabelaPlanos"
      api-route="/planos/"
      item-key="codplano"
      :columns="columns"
      :filters="filters"
      sort-by="codplano"
      :sort-desc="true"
    />
    <FloatBtn text="Cadastrar Plano" @click="abrirDialogPlano()" />
    <CadastroPlanoDialog
      v-model="dialogPlano"
      :plano="planoSelecionado"
      @plano-cadastrado="recarregarTabela"
      :exibe-lista="true"
    />
  </div>
</template>

<script>
import DataTable from './comum/DataTable.vue';
import FloatBtn from './FloatBtn.vue';
import CadastroPlanoDialog from './CadastroPlanoDialog.vue';

export default {
  components: {
    DataTable,
    FloatBtn,
    CadastroPlanoDialog,
  },
  data() {
    return {
      dialogPlano: false,
      planoSelecionado: null,
      columns: [
        { key: 'codplano', title: 'CodPlano' },
        { key: 'nome', title: 'Nome' },
        { key: 'valor', title: 'Valor' },
        { key: 'qtd_usuarios', title: 'Qtd. Usuários' },
        { key: 'codproduto', title: 'Cód. Produto' },
      ],
      filters: [
        { model: 'nome', label: 'Filtrar por Nome', icon: 'mdi-magnify' },
        { model: 'codplano', label: 'Filtrar por Código do Plano', type: 'number', icon: 'mdi-numeric' },
        { model: 'codproduto', label: 'Filtrar por Código do Produto', type: 'number', icon: 'mdi-numeric' },
      ],
    };
  },
  methods: {
    abrirDialogPlano() {
      this.dialogPlano = true;
    },
    recarregarTabela() {
      this.$refs.tabelaPlanos.recarregar();
    }
  },
};
</script>
